import React, {Component} from "react";
import { inject, observer } from "mobx-react";
import {Button, FormGroup, Input, Label, Row, Col} from 'reactstrap';
import {Tabela} from "./Tabela";
import {ModalForm} from "./ModalForm";
import PropTypes from 'prop-types';
import {toast} from "react-toastify";
import Select from "react-select";
import {Validacao} from "./Validacao";
import {Link} from "react-router-dom";
import FontAwesome from 'react-fontawesome';
import _ from "lodash";
import TabelaAdministracaoStore from "../stores/TabelaAdministracaoStore";

//RHFPP-1447-automatizacao-timesheets
@inject("store")
@observer
export class TabelaAdministracao extends Component {
    static propTypes = {
        nomeFluxo: PropTypes.string
    };

    constructor(props) {
        super(props);

        this.modalStore     = this.props.store.modalStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.tabelaStore    = this.props.store.tabelaStore;
        this.formStore      = this.props.store.formStore;
        this.loginStore     = this.props.store.loginStore;
        this.appStore       = this.props.store.appStore;

        this.toggleExaminarFalhaModal = this.toggleExaminarFalhaModal.bind(this);

        this.controller = new TabelaAdministracaoStore(this.loginStore);

    }

    componentDidMount() {
        this.modalStore.setSubmitted(false);
        this.modalStore.setSubmitMensagemErro("");
        this.formStore.setSubmitted(false);
        this.formStore.setSubmitMensagemErro("");
    }

    /* qual modal renderizar */
    modalForm(){
        if (this.modalStore.exibirModal.aberto) {
            switch (this.modalStore.exibirModal.tipo) {
                case 'examinarFalha':
                    return (
                        <ModalForm
                            corpo={this.modalExaminarFalha()}
                            cabecalho={this.props.nomeFluxo + ": Examinar falha" }
                            botoes={this.botoesModalExaminarFalha()}  />
                    );
                }
        }
    }

    modalExaminarFalha = () => {
        return(
            <div>
                <FormGroup>
                    <Label>Erro identificado no processamento</Label>
                    <Input disabled type="textarea" value={this.controller.motivoErro}/>
                    <br/>
                    <br/>
                    <Label>Selecione a ação para o Timesheet</Label>
                    <br/>
                    <Input type="select" id="acaoSelecionada" value={this.controller.acaoSelecionada}
                                        onChange={(event) => this.controller.setAcaoSelecionada(event.target.value)}>
                                                <option value={""}></option>
                                                <option value={"0"}>Liberar o reprocessamento</option>
                                                <option value={"1"}>Cancelar o Timesheet</option>
                    </Input>
                    <Validacao id="acaoSelecionada" valor={this.controller.acaoSelecionada} tipo={["isRequired"]}/>
                    <br/>
                    <br/>
                    {this.controller.acaoSelecionada=="1" && 
                    <Label>Informe o motivo do cancelamento</Label>}
                    {this.controller.acaoSelecionada=="1" && 
                        <Input type="textarea" id="observacaoCancelamento" value={this.controller.observacoes}
                           onChange={(event) => this.controller.setObservacoes(event.target.value)}/>}
                    {this.controller.acaoSelecionada=="1" &&
                        <Validacao id="observacaoCancelamento" valor={this.controller.observacoes} tipo={["isRequired"]}/>}
                </FormGroup>
            </div>
        )
    };

    botoesModalExaminarFalha(){
        return (<div>
            <Button color="primary" disabled={this.modalStore.loading} onClick={() => this.confirmarTratamentoErro(this.controller.timesheetId)}>Confirmar</Button>
            <Button color="secondary" disabled={this.modalStore.loading} onClick={() => this.modalStore.toggleModal()}>Fechar</Button>
        </div>)
    }

    tramitarEmToleETratarResultado = (funcaoTramitacao, mensagemSucesso, ...args) => {
        this.modalStore.setSubmitted(true);
        this.modalStore.setSubmitMensagemErro("");
        if (this.validacaoStore.isValidForm && !this.modalStore.loading) {
            this.modalStore.loading = true;
            funcaoTramitacao(...args).then(response => {
                this.tabelaStore.onSelectAll(false, this.props.listaItens, this.props.keyField);
                if(this.props.controller && this.props.controller.carregarLista){
                    this.props.controller.carregarLista();
                }
                else if(this.props.reload){
                    this.props.reload();
                }
                this.modalStore.toggleModal();
                this.controller.cleanSucessList();
                toast.success(mensagemSucesso);
            }).catch(error => {
                this.modalStore.setSubmitMensagemErro(error.response ? error.response.data.message : error);
                this.modalStore.loading = false;
                //this.controller.cleanErrorList();
            });
        }
    };

    confirmarTratamentoErro = (...args) => this.tramitarEmToleETratarResultado((...props) => this.controller.tratarErroTimesheet(...props), 'Tratamento de Erros realizado.', ...args);

    toggleExaminarFalhaModal = () =>{
        //this.controller.carregarAprovadores();
        this.controller.observacoes = "";
        this.modalStore.toggleModal('examinarFalha');
    }

    visualizarAcao = (row, itemAcao, i) =>{
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";

        let path = null;
        if(row.definicaoTarefaId === "HT_SolicitacaoContratacao") {
            path = "/ajuste-solicitacao/" +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_AjusteSolicitacao" && row.nomeFluxo === "GloboMOTSolicitacaoProrrogacao") {
            path = "/ajuste-prorrogacao/" +_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_AvaliarHorasExtrasGestor") {
            path = "/detalhamento-horas-trabalhadas/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_AjustarHorasExtrasETT") {
            path = "/ajuste-horas-trabalhadas/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.definicaoTarefaId === "HT_LancarHorasExtrasETT") {
            path = "/envio-horas-trabalhadas/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTPagamento") {
            path = "/envio-pagamento/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSubstituicao") {
            path = "/detalhamento-substituicao/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSolicitacaoProrrogacao") {
            path = "/detalhamento-prorrogacao/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSolicitacaoEtt") {
            path = "/detalhamento-solicitacao-ett/tarefa/"+_.get(row,itemAcao.parametro)
        } else if(row.nomeFluxo === "GloboMOTSolicitacaoTerminoAntecipado") {
            path = "/detalhamento-termino-antecipado/tarefa/"+_.get(row,itemAcao.parametro)
        } else {
            path = "/detalhamento/tarefa/"+_.get(row,itemAcao.parametro)
        }
        return <Link key={i} className={"btn btn-secondary " + buttonType + itemAcao.cor} title={itemAcao.label} to={path}><FontAwesome name={itemAcao.icone}/></Link>
    }

    trClassMarcaErro(row, rowIndex) {
        return (row.status == "ERA" || row.status == "ERF") ? "table-row-error":"";;
    }

    visualizarControle = (row, itemAcao, i) =>{
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        return <Link key={i} className={"btn btn-secondary "+ buttonType + itemAcao.cor} title={itemAcao.label} to={"/detalhamento/solicitacao/"+_.get(row,itemAcao.parametro)}><FontAwesome name={itemAcao.icone}/></Link>
    }

    examinarFalha = (row, itemAcao, i) => {
        const buttonType = this.appStore.width > 768 ? "icon-button " : "card-button ";
        const estadoTarefa = _.get(row, "status");
        let icone, cor, t;
        switch (estadoTarefa) {
            case 'ERA': icone = 'exclamation-circle'; cor = 'text-danger'; t = 'Alocação com falha'; break;
            case 'ERF': icone = 'exclamation-circle'; cor = 'text-warning'; t = 'Fluxo com falha'; break;
            default: return null;
        }
        return <Button key={i + '_falha'} className={"btn btn-secondary " + buttonType + cor}
            title={t + itemAcao.label}
            onClick={event => this.tratarFalha(event, row)}
        ><FontAwesome name={icone} /></Button>
    }

    tratarFalha(event, row) {

        this.controller.timesheetId = row;
        this.controller.motivoErro = row.timesheetObservacoes;
        this.modalStore.toggleModal('examinarFalha');
        console.log('RECUPERAR!'); //TODO

    }

    transformaAcoes = (acoesItensList) => {
        const acoesItens = [];
        for (let i = 0; i < acoesItensList.length; i++) {
            switch (acoesItensList[i]) {
                case 'examinarFalha':
                    acoesItens.push({
                        tipo: "examinarFalha",
                        label: "\nExaminar...",
                        parametro: ['timesheetId'],
                        acao: this.examinarFalha
                    });
                    break;
                default:
                    if(this.props.acoesItens[i] && typeof this.props.acoesItens[i] === "object") {
                        acoesItens.push(this.props.acoesItens[i])
                    }
            }
        }

        return acoesItens;
    };

    cardClick = (row, itemAcao, i, acoesItens) => {
        const acaoItem = _.find(acoesItens, {label: "Visualizar"});

        if(acaoItem) {
            return acaoItem.acao(row, itemAcao, i);
        }
    };

    render() {
        /* Especificar Botões no topo da TabelaStore (Se houverem) */
        const acoesMultiplas = [];
        if(this.props.acoesMultiplas) {
            for (let i = 0; i < this.props.acoesMultiplas.length; i++) {
                switch (this.props.acoesMultiplas[i]) {
                    case 'delegar':
                        acoesMultiplas.push({
                            label: "Delegar",
                            icone: "mail-forward",
                            acao: this.toggleDelegarModal
                        });
                        break;
                    case 'adquirir':
                        acoesMultiplas.push({
                            label: "Adquirir",
                            icone: "envelope-open",
                            acao: this.controller.adquirirSelecionados
                        });
                        break;
                    case 'aprovar':
                        acoesMultiplas.push({
                            label: "Aprovar",
                            icone: "thumbs-up",
                            acao: this.toggleAprovarModal
                        });
                        break;
                    case 'aprovarTimesheet':
                        acoesMultiplas.push({
                            label: "Aprovar",
                            icone: "envelope-open",
                            acao: this.toggleAprovarTimesheetModal
                        });
                        break;
                    case 'enviarTimesheet':
                        acoesMultiplas.push({
                            label: "Enviar",
                            icone: "thumbs-up",
                            acao: this.toggleEnviarTimesheetModal
                        });
                        break;
                    case 'cancelar':
                        acoesMultiplas.push({
                            label: "Cancelar",
                            icone: "trash",
                            acao: this.toggleCancelarModal
                        });
                        break;
                }
            }
        }

        /* Especificar botões nos itens da tabela (Se houverem) */
        let acoesItens = [];

        if(this.props.acoesItens) {
            acoesItens = this.transformaAcoes(this.props.acoesItens);
        }

        return (
            <div>
                <Tabela
                    keyField={this.props.keyField}
                    useCardsMobile={true}
                    habilitarSelecaoMultipla={true}
                    listaItens={this.props.listaItens}
                    colunaId={this.props.colunaId}
                    colunaSolicitacaoId={this.props.colunaSolicitacaoId}
                    colunas={this.props.colunas}
                    acoesMultiplas={acoesMultiplas}
                    temBusca={this.props.temBusca}
                    acoesItens={acoesItens}
                    tituloMobile={this.props.tituloMobile}
                    conteudoMobile={this.props.conteudoMobile}
                    extraMobile={this.props.extraMobile}
                    onChange={this.props.onChange}
                    onCardClick={(row, itemAcao, i) => this.cardClick(row, itemAcao, i, acoesItens)}
                    loading={this.props.loading}
                    setTableRef={(...props) => this.controller.setTableRef(...props)}
                    colunaOrdenacaoPadrao={this.props.colunaOrdenacaoPadrao}
                    tipoOrdenacaoPadrao={this.props.tipoOrdenacaoPadrao}
                    recarregar={this.props.recarregar}
                    upload={this.props.upload}
                    botoesDinamicos={this.props.acoesItens === "botoesContratacoesVigentes"}
                    mobileFilter={this.props.mobileFilter}
                    trClassName={this.trClassMarcaErro}
                />
                {this.modalForm()}
            </div>

        );
    }
}